import { createContext } from "react"

export interface AdsInfoInterface {
  _id: any, 
  title: string,
  company: string,
  images: string[]
  finishDate: string,
}

export const DefaultAdsInfoInterface: AdsInfoInterface = {
  _id: "",
  title: "",
  company: "",
  images: [""],
  finishDate: "",
}

export interface ShowAdsInfoInterface {
  showSuccessMsg: boolean, setShowSuccessMsg: (showSuccessMsg: boolean) => void,
  showAddAdsInfoModal: boolean, setShowAddAdsInfoModal: (showAddAdsInfoModal: boolean) => void,
  showEditAdsInfoModal: boolean, setShowEditAdsInfoModal: (showEditAdsInfoModal: boolean) => void,
  showDeleteAdsInfoModal: boolean, setShowDeleteAdsInfoModal: (showDeleteAdsInfoModal: boolean) => void,
  selectedAdsInfo: AdsInfoInterface, setSelectedAdsInfo: (selectedAdsInfo: AdsInfoInterface) => void,
  selectedModal: string, setSelectedModal: (selectedModal: string) => void,
  showDeleteAdsInfoPhotoModal: boolean, setShowDeleteAdsInfoPhotoModal: (showDeleteAdsInfoPhotoModal: boolean) => void,
  selectedPhoto: string, setSelectedPhoto: (selectedPhoto: string) => void,
}

export const DefaultShowAdsInfoInterface: ShowAdsInfoInterface = {
  showSuccessMsg: false, setShowSuccessMsg: () => {},
  showAddAdsInfoModal: false, setShowAddAdsInfoModal: () => {},
  showEditAdsInfoModal: false, setShowEditAdsInfoModal: () => {},
  showDeleteAdsInfoModal: false, setShowDeleteAdsInfoModal: () => {},
  selectedAdsInfo: DefaultAdsInfoInterface, setSelectedAdsInfo: () => {},
  selectedModal: "", setSelectedModal: () => {},
  showDeleteAdsInfoPhotoModal: false, setShowDeleteAdsInfoPhotoModal: () => {},
  selectedPhoto: "", setSelectedPhoto: () => {},
}

export const ShowAdsInfoContext = createContext<ShowAdsInfoInterface>(DefaultShowAdsInfoInterface)

export interface FormDataAdsInfoInterface {
  title: string, setTitle: (title: string) => void,
  company: string, setCompany: (company: string) => void,
  finishDate: string, setFinishDate: (finishDate: string) => void,
  images: File[] | any, setImages: (images: File[] | any) => void,
}

export const DefaultFormDataAdsInfoInterface: FormDataAdsInfoInterface = {
  title: "", setTitle: () => {},
  company: "", setCompany: () => {},
  finishDate: "", setFinishDate: () => {},
  images: null, setImages: () => {},
}

export const FormDataAdsInfoContext = createContext<FormDataAdsInfoInterface>(DefaultFormDataAdsInfoInterface)

export enum modalType {
  AddModal = "AddModal",
  EditModal = "EditModal",
  DeleteModal = "DeleteModal",
}

